export { NgxPicaModule } from './src/ngx-pica.module';
export { NgxPicaService } from './src/ngx-pica.service';
export { NgxPicaImageService } from './src/ngx-pica-image.service';
//# sourceMappingURL=index.js.map